import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import css from 'css';
import { isMobile } from 'helpers';
import { setCheckoutStep } from 'store';

const Container = styled.div`
    position: relative;
    width: 100%;
`;

const Row = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
`;

const Circle = styled.div`
    height: 10px;
    width: 10px;
    border-radius: 50%;
    display: inline-block;
    background-color: ${css.colors.blue};
    margin: 10px;
    left: 25%;

    &.active {
        background-color: #FFF
    }

    &.active:before {
        content: '';
        position: absolute;
        top: -10px;
        left: -10px;
        right: -10px;
        bottom: -10px;
        border: white 2px solid;
        border-radius: 50%;
    }
`;

const Title = styled.h1`
    padding-top: 15px;
    color: #FFFFFF;
`;

const StepContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    padding: 30px;

    @media(max-width: 767px) {
        padding: 5px;
    }
`;

class Progressbar extends Component {

    onHandleClick(current, index) {
        if(current > index) this.props.setCheckoutStep(index);
    }
    
    _renderSteps() {
        const { steps, current, summary } = this.props;

        let content = [];

        for (let i = 0; i < steps.length; i++) {
            
            content.push(
                <StepContainer>
                    <Circle key={i} className={current === i ? 'active' : ''} onClick={() => this.onHandleClick(current, i)}/>
                    {!isMobile() && <Title>{steps[i] && steps[i].title || ''}</Title>}
                </StepContainer>
            );
        }

        return content;
    }


    render() {
        const { steps } = this.props;

        return (
            <Container>
                <Row>
                    {steps && this._renderSteps()}
                </Row>
            </Container>
        )
    }
}


const mapStateToProps = state => ({
    checkoutCart: state.checkoutCart,
});

const actions = {
    setCheckoutStep
}


export default connect(mapStateToProps, actions)(Progressbar);


// WEBPACK FOOTER //
// ./src/partials/shared/Progressbar/Progressbar.js